import { Component, OnInit, AfterViewInit } from '@angular/core';
import {
    Router,
    NavigationStart,
} from '@angular/router';
import { ApplicationInsightsService, FiltersService } from './core/';
import { SettingsProvider } from './core/';
import { AdalService } from 'adal-angular4';

@Component({
    selector: 'pr-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {

    constructor(
        private router: Router,
        private adal: AdalService,
        private settingsService: SettingsProvider,
        private applicationInsightsService: ApplicationInsightsService,
        private filtersService: FiltersService
    ) { }

    ngOnInit() {
        const config = {
            tenant: this.settingsService.configuration.tenant,
            clientId: this.settingsService.configuration.clientId,
            redirectUri: window.location.origin,
        };
        this.adal.init(config);

        this.adal.handleWindowCallback();

        const sub = this.router.events.subscribe((e) => {
            if (e instanceof NavigationStart) {
                sub.unsubscribe();

                if (this.adal.userInfo.authenticated && e.url === '/') {
                    this.router.navigate(['prices']);
                    this.fetchFilters();
                } else if (!this.adal.userInfo.authenticated) {
                    this.router.navigate(['login']);
                } else if (this.adal.userInfo.authenticated) {
                    this.fetchFilters();
                }
            }
        });
    }

    ngAfterViewInit() {
        if (this.adal.userInfo.authenticated) {
            this.applicationInsightsService.setUserId(
                this.adal.userInfo.userName
            );
        } else {
            this.applicationInsightsService.clearUserId();
        }
    }

    private fetchFilters() {
        this.filtersService.fetchFilters().subscribe(
            (response) => this.filtersService.initFilters(response),
            (error) => console.log('not loaded', error)
        );
    }
}
